import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "g-row g-row--appearance_spaced g-row--space_lg-mac" }
const _hoisted_2 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_3 = { class: "g-row g-row--appearance_nowrap g-row--align_center sk-space_pl sk-space_pl--0" }
const _hoisted_4 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_5 = { class: "ds-inliner ds-inliner--size_lg" }
const _hoisted_6 = { class: "ds-inliner__body" }
const _hoisted_7 = { class: "g-cell g-cols g-cols--10" }
const _hoisted_8 = { class: "g-row g-row--appearance_nowrap g-row--align_center sk-space_pl sk-space_pl--0" }
const _hoisted_9 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_10 = { class: "ds-inliner ds-inliner--size_xl" }
const _hoisted_11 = { class: "ds-inliner__body" }
const _hoisted_12 = { class: "g-cell g-cols g-cols--10 ellipsis-content ellipsis-content--1" }
const _hoisted_13 = { class: "g-cell g-cols g-cols--12 g-cols--6-lg" }
const _hoisted_14 = { class: "g-cell g-cols g-cols--12 g-cols--6-lg" }
const _hoisted_15 = { class: "g-row g-row--appearance_spaced g-row--justify_between sk-space_mt sk-space_mt--1" }
const _hoisted_16 = { class: "g-cell g-cols" }
const _hoisted_17 = { class: "ds-caption ds-caption--color_1 ds-caption--size_2xs" }
const _hoisted_18 = { class: "g-cell g-cols" }
const _hoisted_19 = { class: "ds-caption ds-caption--color_1 ds-caption--size_2xs" }
const _hoisted_20 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_21 = { class: "g-row g-row--justify_center g-row--align_center" }
const _hoisted_22 = { class: "g-cell g-cols" }
const _hoisted_23 = {
  key: 0,
  class: "ds-caption ds-caption--appearance_lh_sm ds-caption--size_sm ds-caption--appearance_bold ds-caption--color_1"
}
const _hoisted_24 = {
  key: 0,
  class: "ds-caption ds-caption--size_2xl ds-caption--appearance_lh_sm ds-caption--appearance_bold"
}
const _hoisted_25 = {
  key: 0,
  class: "g-cell g-cols g-cols--auto"
}
const _hoisted_26 = {
  key: 0,
  class: "ds-caption ds-caption--appearance_right ds-caption--appearance_lh_sm ds-caption--appearance_bold"
}
const _hoisted_27 = { class: "ds-caption ds-caption--size_sm ds-caption--color_danger ds-caption--appearance_center ds-caption--appearance_lh_2xs" }
const _hoisted_28 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_29 = {
  key: 0,
  class: "g-cell g-cols g-cols--12"
}
const _hoisted_30 = {
  key: 1,
  class: "g-cell g-cols g-cols--12"
}
const _hoisted_31 = { class: "g-row g-row--appearance_spaced g-row--space_lg-mac g-row--space_xl-fhd" }
const _hoisted_32 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_33 = { class: "g-cell g-cols g-cols--12 g-cols--auto-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DSelect = _resolveComponent("DSelect")!
  const _component_VueSlider = _resolveComponent("VueSlider")!
  const _component_DInput = _resolveComponent("DInput")!
  const _component_vee_error = _resolveComponent("vee-error")!
  const _component_ControlButton = _resolveComponent("ControlButton")!
  const _component_UserAccessState = _resolveComponent("UserAccessState")!
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createBlock(_component_VeeForm, {
    onSubmit: $setup.request,
    ref: "formRef"
  }, {
    default: _withCtx(({ errors, validate, values, setFieldError, isSubmitting }) => [
      _createVNode(_component_LoadingWrapper, {
        loading: isSubmitting || $setup.loadingState?.loading.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_DSelect, {
                  name: "targetCountry",
                  id: "targetCountry",
                  "label-by": 'title',
                  "track-by": 'id',
                  "allow-empty": false,
                  "input-label": $setup.labels.targetCountry,
                  modelValue: $setup.form.targetCountry,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.targetCountry) = $event)),
                  "internal-search": false,
                  searchable: true,
                  loading: $setup.targetCountriesLoading,
                  options: $setup.targetCountriesList,
                  onSearchChange: e => $setup.targetCountriesSearch(e),
                  onGetItems: $setup.targetCountriesGet.bind(null)
                }, {
                  option: _withCtx(({ option }) => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["fi fis flag-wrap", `fi-${(option.code2).toLowerCase()}`])
                            }, null, 2)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", null, _toDisplayString(" " + option.title), 1)
                      ])
                    ])
                  ]),
                  singleLabel: _withCtx(({ option }) => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["fi fis flag-wrap", `fi-${(option.code2).toLowerCase()}`])
                            }, null, 2)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", null, _toDisplayString(" " + option.title), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["input-label", "modelValue", "loading", "options", "onSearchChange", "onGetItems"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_DInput, {
                  name: "downPayment",
                  id: "downPayment",
                  "input-label": $setup.labels.downPayment,
                  size: ['md', 'md-xl'],
                  type: "number",
                  modelValue: $setup.form.downPayment,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.form.downPayment = Number($event))),
                  rules: `required|minValue:${$setup.downPaymentConfig?.min || 0}|maxValue:${$setup.downPaymentConfig?.max || 1}`,
                  disabled: !($setup.downPaymentConfig && $setup.form.priceAmount)
                }, {
                  slider: _withCtx(({}) => [
                    _createVNode(_component_VueSlider, _mergeProps({
                      silent: true,
                      modelValue: $setup.form.downPayment,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.downPayment) = $event))
                    }, { ...$setup.defaultSliderOptions }, {
                      min: $setup.downPaymentConfig?.min || 0,
                      max: $setup.downPaymentConfig?.max || 1,
                      disabled: !($setup.downPaymentConfig && $setup.form.priceAmount),
                      lazy: true
                    }), null, 16, ["modelValue", "min", "max", "disabled"])
                  ]),
                  _: 1
                }, 8, ["input-label", "modelValue", "rules", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_DInput, {
                  name: "period",
                  id: "period",
                  "input-label": $setup.labels.period,
                  size: ['md', 'md-xl'],
                  type: "number",
                  modelValue: $setup.form.period,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.form.period = Number($event))),
                  rules: `required|minValue:${$setup.currentConfig?.leasePeriodMin || 0}|maxValue:${$setup.currentConfig?.leasePeriodMax || 1}`,
                  disabled: !($setup.currentConfig?.leasePeriodDefault)
                }, {
                  slider: _withCtx(({}) => [
                    _createVNode(_component_VueSlider, _mergeProps({
                      silent: true,
                      modelValue: $setup.form.period,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.period) = $event))
                    }, { ...$setup.defaultSliderOptions }, {
                      min: $setup.currentConfig?.leasePeriodMin || 0,
                      max: $setup.currentConfig?.leasePeriodMax || 1,
                      disabled: !($setup.currentConfig?.leasePeriodDefault),
                      lazy: true
                    }), null, 16, ["modelValue", "min", "max", "disabled"])
                  ]),
                  _: 1
                }, 8, ["input-label", "modelValue", "rules", "disabled"]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString($setup.currentConfig?.leasePeriodMin ? $setup.pluralFinancingPeriodMin : "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString($setup.currentConfig?.leasePeriodMax ? $setup.pluralFinancingPeriodMax : "-"), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    ($setup.result)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                          ($setup.result?.priceMonthly)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$n(Number($setup.result?.priceMonthly) || 0, 'currency')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, " " + _toDisplayString(_ctx.$t("/ month")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  ($setup.isPermittedSimple([$setup.OFFER.VIEW_PRICE]) || $props.is_owner || $props.is_machinery_owner)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        ($setup.form?.priceAmount)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$n(Number($setup.form?.priceAmount) || 0, 'currency')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_vee_error, {
                class: "g-cell g-cols g-cols--12",
                name: "nonFieldErrors",
                as: "div"
              }, {
                default: _withCtx(({ message }) => [
                  _createElementVNode("p", _hoisted_27, _toDisplayString(message), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("p", {
                  class: _normalizeClass(["ds-caption ds-caption--size_sm ds-caption--color_danger ds-caption--appearance_center ds-caption--appearance_lh_2xs", { 'is-visibility-hidden': !$setup.isShowCountryError }]),
                  ref: "targetCountryRef"
                }, _toDisplayString(_ctx.$t("Please select the delivery country for this machinery")), 3)
              ]),
              _createVNode(_component_UserAccessState, {
                permissions: [$setup.IS_MANAGER]
              }, {
                default: _withCtx(({ hasAccess: isManager }) => [
                  _createVNode(_component_UserAccessState, {
                    permissions: [$setup.IS_CUSTOMER]
                  }, {
                    default: _withCtx(({ hasAccess: isCustomer }) => [
                      _createVNode(_component_UserAccessState, {
                        permissions: [$setup.IS_DEALER]
                      }, {
                        default: _withCtx(({ hasAccess: isDealer }) => [
                          ($setup.IS_AUTH && ($props.is_machinery_owner || $props.is_owner || isManager) && !isCustomer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createVNode(_component_ControlButton, {
                                  tag: "a",
                                  href: $setup.router.resolve({ name: $setup.COMMERCIAL_OFFERS_CREATE, query: { offer: $props.offerId, target: $setup.form.targetCountry?.id, target_uuid: $setup.form.targetCountry?.uuid, target_title: $setup.form.targetCountry?.title, target_code: $setup.form.targetCountry?.code2 } }).fullPath,
                                  target: "_blank",
                                  styling: "primary",
                                  type: "button",
                                  size: ['md', 'lg-xl'],
                                  view: ['full']
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Save commercial offer")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["href"])
                              ]))
                            : (!$setup.IS_AUTH || (isDealer && !($props.is_owner || $props.is_machinery_owner)) || isCustomer)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                      _createVNode(_component_ControlButton, {
                                        type: "button",
                                        styling: "primary",
                                        size: ['md', 'lg-xl'],
                                        view: ['full'],
                                        target: "_blank",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.use_future_applying_for_financing ? $setup.redirectToApplyingForFinancing() : $setup.openBuyNowModal()))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("Buy now")), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_33, [
                                      _createVNode(_component_ControlButton, {
                                        styling: "dark",
                                        type: "button",
                                        variant: "outlined",
                                        view: "full",
                                        size: ['md', 'lg-xl'],
                                        onClick: ($event: any) => ($setup.openGetAnOfferModal(isCustomer))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("Get an offer")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["permissions"])
                    ]),
                    _: 2
                  }, 1032, ["permissions"])
                ]),
                _: 1
              }, 8, ["permissions"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["loading"])
    ]),
    _: 1
  }, 512))
}